<template>
  <div class="text-center">
    <v-dialog width="500" v-model="isOpen" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          更新確認
        </v-card-title>
        <br />
        <v-card-subtitle>
          このトピックは既に更新されています。<br />
          今の編集状態を破棄し、最新のトピックを反映しますか？
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="sendUpdated(false)">
            戻る
          </v-btn>
          <v-btn color="primary" text @click="sendUpdated(true)">
            更新
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: this.isOpen
    };
  },
  name: 'TopicEditConflictConfirmModal',
  props: {
    isOpen: {
      type: Boolean,
    }
  },
  methods: {
    sendUpdated(isSetLatestTopic) {
      this.$emit("isSetLatestTopic", isSetLatestTopic);
    },
  },
};
</script>